<template>
	<div>
		<b-alert :show="!!error" variant="danger">{{error?.error||error}}</b-alert>
		<div class="d-flex flex-wrap mb-3" style="gap: 0.5rem">
			<b-button variant="secondary" class="flex-fill" to="/widgets/voices?lang=en"><b-icon icon="soundwave" class="mr-1" />TTS Voices</b-button>
			<b-button variant="secondary" class="flex-fill" to="/widgets/replacements"><b-icon icon="file-earmark-font-fill" class="mr-1" />Word replacements</b-button>
			<b-button variant="secondary" class="flex-fill" to="/widgets/event-media"><b-icon icon="music-note-beamed" class="mr-1" />Alert sounds</b-button>
			<b-button variant="secondary" class="flex-fill" to="/widgets/dono-media"><b-icon icon="piggy-bank-fill" class="mr-1" />Platform alert sounds</b-button>
			<b-button variant="secondary" class="flex-fill" to="/widgets/tower-detector"><b-icon icon="sort-alpha-down" class="mr-1" />Tower detector</b-button>
			<b-button variant="secondary" class="flex-fill" to="/widgets/thresholds"><b-icon icon="bar-chart-fill" class="mr-1" />Song request thresholds</b-button>
		</div>
		<b-form-row>
			<b-col cols="12" lg="6">
				<b-card class="mb-3">
					<div class="d-flex justify-content-between align-items-center mb-3">
						<h5 class="card-title"><b-icon icon="chat-dots-fill" class="mr-2" />Chat widget <b-spinner v-show="chatLoading" label="Loading" class="ml-1 spinner-border-sm"></b-spinner></h5>
						<b-dropdown split size="sm" variant="primary" split-to="/widgets/chat" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="openPopup(`${$baseUrl}/app/chatWidgetSettings.html`, 400, 300)"><b-icon icon="box-arrow-up-right" class="mr-1" />Pop out quick settings</b-dropdown-item>
							<b-dropdown-item @click="$util.copyToClipboard(`${$baseUrl}/app/chatWidgetSettings.html`)"><b-icon icon="clipboard" class="mr-1" />Copy browser dock URL</b-dropdown-item>
							<b-dropdown-divider />
							<b-dropdown-item @click="refreshWidget('chat')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
						</b-dropdown>
					</div>
					<chat-widget-settings-content @loading="chatLoading = $event" />
					<widget-url class="mt-3" :url="`${$baseUrl}/widget/chat.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
				</b-card>
				<b-card class="mb-3">
					<div class="d-flex justify-content-between align-items-center mb-3">
						<h5 class="card-title"><b-icon icon="person-plus-fill" class="mr-2" />Follower goal <b-spinner v-show="followerGoalLoading" label="Loading" class="ml-1 spinner-border-sm"></b-spinner></h5>
						<b-dropdown split size="sm" variant="primary" split-to="/widgets/follower-goal" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="openPopup(`${$baseUrl}/app/followerGoalSettings.html`, 400, 280)"><b-icon icon="box-arrow-up-right" class="mr-1" />Pop out quick settings</b-dropdown-item>
							<b-dropdown-item @click="$util.copyToClipboard(`${$baseUrl}/app/followerGoalSettings.html`)"><b-icon icon="clipboard" class="mr-1" />Copy browser dock URL</b-dropdown-item>
							<b-dropdown-divider />
							<b-dropdown-item @click="refreshWidget('follower-goal')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
						</b-dropdown>
					</div>
					<follower-goal-settings-content @loading="followerGoalLoading = $event" />
					<widget-url class="mt-3" :url="`${$baseUrl}/widget/followerGoal.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
				</b-card>
				<b-card class="mb-3">
					<div class="d-flex justify-content-between align-items-center mb-3">
						<h5 class="card-title"><b-icon icon="people-fill" class="mr-2" />Viewer count widget</h5>
						<b-dropdown split size="sm" variant="primary" split-to="/widgets/viewer-count" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="refreshWidget('viewer-count')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
						</b-dropdown>
					</div>
					<widget-url :url="`${$baseUrl}/widget/viewerCount.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
				</b-card>
				<b-card class="mb-3">
					<div class="d-flex justify-content-between align-items-center mb-3">
						<h5 class="card-title"><b-icon icon="pin-angle-fill" class="mr-2" />Highlighted message</h5>
						<b-dropdown split size="sm" variant="primary" split-to="/widgets/highlighted-message" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="refreshWidget('highlighted-message')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
							<b-dropdown-divider />
							<b-dropdown-item @click="$api.post('selectMessage', null).catch(e => console.error('Clear highlighted message failed', e))"><b-icon icon="x-circle" class="mr-1" />Clear current message</b-dropdown-item>
						</b-dropdown>
					</div>
					<widget-url :url="`${$baseUrl}/widget/highlightedMessage.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
				</b-card>
				<b-card class="mb-3">
					<div class="d-flex justify-content-between align-items-center mb-3">
						<h5 class="card-title"><b-icon icon="person-plus-fill" class="mr-2" />Latest follower</h5>
						<b-dropdown split size="sm" variant="primary" split-to="/widgets/latest-follower" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="refreshWidget('latest-follower')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
						</b-dropdown>
					</div>
					<widget-url :url="`${$baseUrl}/widget/latestFollower.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
				</b-card>
				<b-card class="mb-3">
					<div class="d-flex justify-content-between align-items-center mb-3">
						<h5 class="card-title"><b-icon icon="star-fill" class="mr-2" />Latest member</h5>
						<b-dropdown split size="sm" variant="primary" split-to="/widgets/latest-subscriber" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="refreshWidget('latest-subscriber')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
						</b-dropdown>
					</div>
					<widget-url :url="`${$baseUrl}/widget/latestSubscriber.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
				</b-card>
				<b-card class="mb-3">
					<div class="d-flex justify-content-between align-items-center mb-3">
						<h5 class="card-title"><b-icon icon="arrow-left-right" class="mr-2" />Scroller widget</h5>
						<b-dropdown split size="sm" variant="primary" split-to="/widgets/scroller" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="refreshWidget('scroller')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
						</b-dropdown>
					</div>
					<widget-url :url="`${$baseUrl}/widget/scroller.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
				</b-card>
			</b-col>
			<b-col cols="12" lg="6">
				<b-card class="mb-3">
					<div class="d-flex justify-content-between align-items-center mb-3">
						<h5 class="card-title"><b-icon icon="bell-fill" class="mr-2" />Alert widget <b-spinner v-show="alertLoading" label="Loading" class="ml-1 spinner-border-sm"></b-spinner></h5>
						<b-dropdown split size="sm" variant="primary" split-to="/widgets/gift" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="openPopup(`${$baseUrl}/app/alertWidgetSettings.html`, 400, 320)"><b-icon icon="box-arrow-up-right" class="mr-1" />Pop out quick settings</b-dropdown-item>
							<b-dropdown-item @click="$util.copyToClipboard(`${$baseUrl}/app/alertWidgetSettings.html`)"><b-icon icon="clipboard" class="mr-1" />Copy browser dock URL</b-dropdown-item>
							<b-dropdown-divider />
							<b-dropdown-item @click="refreshWidget('gift')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
						</b-dropdown>
					</div>
					<alert-widget-settings-content @loading="alertLoading = $event" />
					<widget-url class="mt-3" :url="`${$baseUrl}/widget/gift.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
				</b-card>
				<b-overlay :show="!!(user.id && !user.is_subscribed)" variant="dark" opacity="0.75" class="mb-3">
					<b-card>
						<div class="d-flex justify-content-between align-items-center mb-3">
							<h5 class="card-title"><b-icon icon="trophy-fill" class="mr-2" />Gift goal <b-spinner v-show="giftGoalLoading" label="Loading" class="ml-1 spinner-border-sm"></b-spinner></h5>
							<b-dropdown split size="sm" variant="primary" split-to="/widgets/gift-goal" right>
								<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
								<b-dropdown-item @click="openPopup(`${$baseUrl}/app/giftGoalSettings.html`, 400, 280)"><b-icon icon="box-arrow-up-right" class="mr-1" />Pop out quick settings</b-dropdown-item>
								<b-dropdown-item @click="$util.copyToClipboard(`${$baseUrl}/app/giftGoalSettings.html`)"><b-icon icon="clipboard" class="mr-1" />Copy browser dock URL</b-dropdown-item>
								<b-dropdown-divider />
								<b-dropdown-item @click="refreshWidget('gift-goal')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
							</b-dropdown>
						</div>
						<gift-goal-settings-content @loading="giftGoalLoading = $event" />
						<widget-url class="mt-3" :url="`${$baseUrl}/widget/giftGoal.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
					</b-card>
					<template #overlay>
						<div class="text-center mx-n3">
							<p class="mb-3">The gift goal widget is available for subscribed users only.</p>
							<b-button variant="warning" @click="$root.$emit('show-upgrade-modal')">Upgrade</b-button>
						</div>
					</template>
				</b-overlay>
				<b-overlay :show="!!(user.id && !user.is_subscribed)" variant="dark" opacity="0.75" class="mb-3">
					<b-card>
						<div class="d-flex justify-content-between align-items-center mb-3">
							<h5 class="card-title"><b-icon icon="bar-chart-steps" class="mr-2" />Membership goal <b-spinner v-show="subGoalLoading" label="Loading" class="ml-1 spinner-border-sm"></b-spinner></h5>
							<b-dropdown split size="sm" variant="primary" split-to="/widgets/sub-goal" right>
								<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
								<b-dropdown-item @click="openPopup(`${$baseUrl}/app/subGoalSettings.html`, 400, 280)"><b-icon icon="box-arrow-up-right" class="mr-1" />Pop out quick settings</b-dropdown-item>
								<b-dropdown-item @click="$util.copyToClipboard(`${$baseUrl}/app/subGoalSettings.html`)"><b-icon icon="clipboard" class="mr-1" />Copy browser dock URL</b-dropdown-item>
								<b-dropdown-divider />
								<b-dropdown-item @click="refreshWidget('sub-goal')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
							</b-dropdown>
						</div>
						<sub-goal-settings-content @loading="subGoalLoading = $event" />
						<widget-url class="mt-3" :url="`${$baseUrl}/widget/subGoal.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
					</b-card>
					<template #overlay>
						<div class="text-center mx-n3">
							<p class="mb-3">The membership goal widget is available for subscribed users only.</p>
							<b-button variant="warning" @click="$root.$emit('show-upgrade-modal')">Upgrade</b-button>
						</div>
					</template>
				</b-overlay>
				<b-overlay :show="!!(user.id && !user.is_subscribed)" variant="dark" opacity="0.75" class="mb-3">
					<b-card>
						<div class="d-flex justify-content-between align-items-center mb-3">
							<h5 class="card-title"><b-icon icon="emoji-smile-fill" class="mr-2" />Emote wall</h5>
							<b-dropdown split size="sm" variant="primary" split-to="/widgets/emote-wall" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="refreshWidget('emote-wall')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
						</b-dropdown>
						</div>
						<widget-url :url="`${$baseUrl}/widget/emoteWall.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
					</b-card>
					<template #overlay>
						<div class="text-center mx-n3">
							<p class="mb-3">The emote wall widget is available for subscribed users only.</p>
							<b-button variant="warning" @click="$root.$emit('show-upgrade-modal')">Upgrade</b-button>
						</div>
					</template>
				</b-overlay>
				<b-overlay :show="!!(user.id && !user.is_pro)" variant="dark" opacity="0.75" class="mb-3">
					<b-card>
						<div class="d-flex justify-content-between align-items-center mb-3">
							<h5 class="card-title"><span class="mr-2">💀</span>Ban reaper</h5>
							<b-dropdown split size="sm" variant="primary" split-to="/widgets/ban-reaper" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="refreshWidget('ban-reaper')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
						</b-dropdown>
						</div>
						<widget-url :url="`${$baseUrl}/widget/banReaper.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
					</b-card>
					<template #overlay>
						<div class="text-center mx-n3">
							<p class="mb-3">The ban reaper widget is available for Pro subscribers only.</p>
							<b-button variant="warning" @click="$root.$emit('show-upgrade-modal')">Upgrade</b-button>
						</div>
					</template>
				</b-overlay>
				<b-overlay :show="!!(user.id && !user.is_subscribed)" variant="dark" opacity="0.75" class="mb-3">
					<b-card>
						<div class="d-flex justify-content-between align-items-center mb-3">
							<h5 class="card-title"><b-icon icon="cloud-fill" class="mr-2" />Word cloud</h5>
							<b-dropdown split size="sm" variant="primary" split-to="/widgets/word-cloud" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="refreshWidget('word-cloud')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
						</b-dropdown>
						</div>
						<widget-url :url="`${$baseUrl}/widget/wordCloud.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
					</b-card>
					<template #overlay>
						<div class="text-center mx-n3">
							<p class="mb-3">The word cloud widget is available for subscribed users only.</p>
							<b-button variant="warning" @click="$root.$emit('show-upgrade-modal')">Upgrade</b-button>
						</div>
					</template>
				</b-overlay>
				<b-card class="mb-3">
					<div class="d-flex justify-content-between align-items-center mb-3">
						<h5 class="card-title"><b-icon icon="piggy-bank-fill" class="mr-2" />Latest donation</h5>
						<b-dropdown split size="sm" variant="primary" split-to="/widgets/latest-donation" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="refreshWidget('latest-donation')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
						</b-dropdown>
					</div>
					<widget-url :url="`${$baseUrl}/widget/latestDonation.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
				</b-card>
				<b-card class="mb-3">
					<div class="d-flex justify-content-between align-items-center mb-3">
						<h5 class="card-title"><b-icon icon="trophy-fill" class="mr-2" />Top donation</h5>
						<b-dropdown split size="sm" variant="primary" split-to="/widgets/top-donation" right>
							<template #button-content><b-icon icon="gear" class="mr-1" /><span class="d-md-none d-lg-inline">Settings</span></template>
							<b-dropdown-item @click="refreshWidget('top-donation')"><b-icon icon="arrow-clockwise" class="mr-1" />Refresh widget</b-dropdown-item>
						</b-dropdown>
					</div>
					<widget-url :url="`${$baseUrl}/widget/topDonation.html?hash=${encodeURIComponent(user.widget_hash||'')}`" />
				</b-card>
			</b-col>
		</b-form-row>
	</div>
</template>

<script>
import WidgetUrl from '@/components/Widget/WidgetUrl.vue';
import ChatWidgetSettingsContent from '@/components/Widget/ChatWidgetSettingsContent.vue';
import AlertWidgetSettingsContent from '@/components/Widget/AlertWidgetSettingsContent.vue';
import GiftGoalSettingsContent from '@/components/Widget/GiftGoalSettingsContent.vue';
import SubGoalSettingsContent from '@/components/Widget/SubGoalSettingsContent.vue';
import FollowerGoalSettingsContent from '@/components/Widget/FollowerGoalSettingsContent.vue';

export default {
	components: { WidgetUrl, ChatWidgetSettingsContent, AlertWidgetSettingsContent, GiftGoalSettingsContent, SubGoalSettingsContent, FollowerGoalSettingsContent },
	data() { return {
		error: null,
		user: {},
		chatLoading: false,
		alertLoading: false,
		giftGoalLoading: false,
		subGoalLoading: false,
		followerGoalLoading: false,
	}},
	async mounted() {
		try {
			this.error = null;
			this.user = await this.$api.get('userData');
			this.subId = this.$socket.subscribe(this.user.widget_hash, {
				userChanged: async () => { this.user = await this.$api.get('userData'); },
			});
		} catch(e) {
			console.error(e);
			this.error = e;
		}
	},
	beforeDestroy() {
		this.subId && this.$socket.unsubscribe(this.subId);
	},
	methods: {
		openPopup(url, width, height) {
			window.open(url, 'winname', `directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=${width},height=${height}`);
		},
		refreshWidget(type) {
			this.$api.post(`widgetRefresh/${encodeURIComponent(type)}`).catch(e => console.error('Refresh widget failed', e));
		},
	},
};
</script>
